import { clsx } from 'clsx';
import React from 'react';
import { imagePath } from '@common/services/images-service';

export const LoadingState = ({
  loading = true,
  align,
  size = 'lg',
  className,
}: {
  loading?: boolean;
  align?: 'center' | 'right';
  size?: 'lg' | 'md' | 'sm';
  className?: string;
}) => {
  if (!loading) {
    return null;
  }

  const sizes = {
    lg: { logo: '32px', dot: '6px', padding: '1rem' },
    md: { logo: '24px', dot: '5px', padding: '0.7rem' },
    sm: { logo: '16px', dot: '3px', padding: '0.5rem' },
  };

  return (
    <span
      className={clsx(['loading-state', `loading-state--${align}`, className])}
    >
      <img
        alt="Trusted Works loading"
        className="logo"
        src={imagePath('./works-logo-elm.svg')}
        width={sizes[size].logo}
      />
      <img
        alt="Works loading ellipsis dot"
        className="works-dot"
        src={imagePath('./works-dot-elm.svg')}
        width={sizes[size].dot}
      />
      <img
        alt="Works loading ellipsis dot"
        className="works-dot"
        src={imagePath('./works-dot-elm.svg')}
        width={sizes[size].dot}
      />
      <style jsx>{`
        .loading-state {
          display: flex;
          align-items: flex-end;
          padding: ${sizes[size].padding};
        }

        .loading-state--center {
          justify-content: center;
        }

        .loading-state--right {
          justify-content: flex-end;
        }

        .loading-state > img {
          margin-right: 2px;
        }

        .loading-state > .works-dot {
          transform: translateY(0px);
          animation: 0.5s ease-in-out infinite alternate raise-fall;
        }

        @keyframes raise-fall {
          0% {
            transform: translateY(0px);
          }
          100% {
            transform: translateY(-2px);
          }
        }

        .loading-state .works-dot:nth-of-type(1) {
          animation-delay: 0.2s;
        }
        .loading-state .works-dot:nth-of-type(2) {
          animation-delay: 0.4s;
        }
      `}</style>
    </span>
  );
};
